/**
 * Device Detection and App Store Auto-Redirect Module
 * Automatically detects iOS/Mac/Android devices and redirects to appropriate app store
 */

(function() {
  'use strict';

  /**
   * Detect if device is iOS (iPhone, iPad, iPod)
   * @returns {boolean}
   */
  function isIOS() {
    const userAgent = navigator.userAgent || window.opera;
    return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  }

  /**
   * Detect if device is Mac (macOS)
   * @returns {boolean}
   */
  function isMac() {
    const userAgent = navigator.userAgent || window.opera;
    const platform = navigator.platform || '';

    // Check for Mac in user agent or platform
    return /Macintosh|MacIntel|MacPPC|Mac68K/i.test(userAgent) ||
           /Mac/i.test(platform) ||
           (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(platform));
  }

  /**
   * Detect if device is Apple device (iOS or Mac)
   * @returns {boolean}
   */
  function isAppleDevice() {
    return isIOS() || isMac();
  }

  /**
   * Detect if device is Android
   * @returns {boolean}
   */
  function isAndroid() {
    const userAgent = navigator.userAgent || window.opera;
    return /android/i.test(userAgent);
  }

  /**
   * Get appropriate app store URL based on device
   * @param {string} iosUrl - iOS/Mac App Store URL
   * @param {string} androidUrl - Android Play Store URL
   * @returns {string|null}
   */
  function getAppStoreUrl(iosUrl, androidUrl) {
    if (isAppleDevice()) {
      return iosUrl;
    }
    if (isAndroid()) {
      return androidUrl;
    }
    return null;
  }

  /**
   * Perform redirect to app store
   * @param {string} url - URL to redirect to
   */
  function redirect(url) {
    if (url) {
      window.location.href = url;
    }
  }

  /**
   * Initialize auto-redirect
   */
  function init() {
    const autoRedirectElement = document.querySelector('[data-device-redirect="auto"]');

    if (autoRedirectElement) {
      const iosUrl = autoRedirectElement.dataset.iosUrl;
      const androidUrl = autoRedirectElement.dataset.androidUrl;

      if (iosUrl && androidUrl) {
        const url = getAppStoreUrl(iosUrl, androidUrl);

        if (url) {
          // Small delay to ensure page has loaded
          setTimeout(() => {
            redirect(url);
          }, 100);
        }
      }
    }
  }

  // Auto-initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM already loaded
    init();
  }
})();
